module.exports = __webpack_public_path__ + "static/media/exclamation-circle.ce5d4432.svg";